import { render, staticRenderFns } from "./Detail-User.vue?vue&type=template&id=a5275678&scoped=true"
import script from "./Detail-User.vue?vue&type=script&lang=js"
export * from "./Detail-User.vue?vue&type=script&lang=js"
import style0 from "./Detail-User.vue?vue&type=style&index=0&id=a5275678&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5275678",
  null
  
)

export default component.exports